//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $productSnManager from "@/Manager/10.Tms/ProductSnManager";
import $reportManager from "@/Manager/10.Tms/ReportManager";

import { Dialog } from "vant";
import { Loading } from "vant";
export default {
  data() {
    return {
      shows: false,
      value: "", 
      list: "",
      ReportImageFiles: [],
      show_two: false,
      productSn:'',
      //扫描后sn
      nums:''
    };
  },

  created() {
    this.$emit("switchIndex", 1);
    this.productSn = $productSnManager.getQueryProductSn(this);
  },
  mounted() {

  },
  methods: {
    onHomeClick() {
      this.$emit("switchIndex", 0);
      this.$router.push("/daddybaby/Tms/ProductSn/Home?Sn="+this.productSn);
    },

    onQueryReportClick() {
      this.$emit("switchIndex",2);
      this.$router.push("/daddybaby/Tms/ProductSn/BrandStory?Sn="+this.productSn);
    },

    zai: function() {
      this.shows = !this.shows;
    },
    zais() {
      this.show_two = !this.show_two;
    },
    // 检验质检报告
    async onViewRportTestClick(){
      this.show_two = !this.show_two;

      this.$msg.showLoading();
      var result = await $reportManager.getReportTest(this.productSn);
      if(result && result.state == 1){
        this.ReportImageFiles = result.data.ProductSn.TraceProductReportImageFileList;
        console.log(this.ReportImageFiles,'图片==============')
        this.$msg.succ("加载成功");
        return;
      }
      this.$msg.hideLoading();

    }, //产品执行标准
    async onViewRportStandardClick() {
      (this.shows = !this.shows);

      this.$msg.showLoading();
      var result = await $reportManager.getReportStandard(this.productSn);
      if(result && result.state == 1){
        this.ReportImageFiles = result.data.ProductSn.TranceProduct.TraceProductReportImageFiles;
        this.$msg.succ("加载成功");
        return;
      }
      this.$msg.hideLoading();
    },

    //开始追溯
    async onQueryProductSnClick() {
      this.$msg.showLoading();
      var sn = this.value;
      var result = await $productSnManager.getProductSn(sn);
      if(result && result.state == 1){
        this.$router.push({
              path: "/daddybaby/Tms/ProductSn/Home",
              query: { sn: this.value }
            });
        this.$msg.succ("成功");
        this.$emit("switchIndex", 0);
        return;

      }else{
        this.$msg.fail("身份码错误");
        return;
      }
    },

    //微信扫一扫
    scanQrCode() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode"],
        success: res1 => {
        this.nums=res1.resultStr.split("=")[1]  
        this.$router.push("/daddybaby/Tms/ProductSn/Home?sn="+this.nums)
          console.log("开始扫码", res1);
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
